import { useEffect, useRef, useState } from 'react';
import { MdPerson, MdLock, MdVisibility, MdVisibilityOff, MdDomain, MdGroups } from 'react-icons/md';
import '../styles/global.css';
import '../styles/pages/Login.css';

import itaipuLogo from '../images/itaipu.png';
import iatipuBackLogo from '../images/itaipu_back.png';
import adabLogo from '../images/itaipu.png';
import aibaLogo from '../images/aiba.png';

import { useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as LogoEmbrapa } from '../images/embrapa.svg';
import { ReactComponent as MonitoraBahiaIcon } from '../images/monitorabahia.svg';
import * as mapas from '../utils/mapas';
import { ProgressBar } from 'primereact/progressbar';
import { Toast } from 'primereact/toast';
import CadastroPessoa from './dialogs/CadastroPessoa';
import { InputMask, InputMaskChangeEvent } from 'primereact/inputmask';
import RecuperarSenhaDialog from './dialogs/RecuperarSenhaDialog';
import { newPessoa, PessoaType, StationData } from '../db/Orm';
import { Dialog } from 'primereact/dialog';
import axios from 'axios';
import Auth from '../auth/Authenticator';
import { LatLngBounds, LatLngTuple } from 'leaflet';

export const enum TIPO_MASK {
  PJ = "99.999.999/9999-99",
  PF = "999.999.999-99"
}

function Login() {
  const auth = Auth.useAuth();
  const navigate = useNavigate();
  const location = useLocation()
  const token_invalid = location.state
  const mapRef = useRef<any>(null);
  const [cpf, setCPF] = useState("");
  const [password, setPassword] = useState("");
  const [errorCPF, setErrorCPF] = useState("");
  const [errorPass, setErrorPass] = useState(token_invalid ? 'Entre novamente!' : '');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false)
  const toast = useRef<Toast | null>(null)

  const [showDialogCadastroPessoa, setShowDialogCadastroPessoa] = useState(false)
  const [showRecuperarSenha, setShowRecuperarSenha] = useState(false);
  const [showTutorialDialog, setShowTutorialDialog] = useState(false);
  const [pessoa, setPessoa] = useState<PessoaType>(newPessoa)
  const [activeIndex, setActiveIndex] = useState(0)
  const [mask, setMask] = useState(TIPO_MASK.PF)

  const loadMap = () => {
    try {
      const sudoeste: LatLngTuple = [-25.46483100000000022, -54.86108600000000024];
      const nordeste: LatLngTuple = [-24.00430700000000073, -54.11667599999999823];
      const limites = [sudoeste, nordeste];
      const mapa = mapas.createMap(mapRef, mapas.mapas.openStreetMap(), [], false, false, false).setMaxBounds(limites);
      const centro: LatLngTuple = [-24.734569, -54.488881];

      mapa.flyTo(centro, 10, {
        duration: 4,
        easeLinearity: 0.25
      });
    } catch (e: any) {
    }
  }
  useEffect(() => {
    const verify = async () => {
      await auth.verifyCookies(token_invalid, () => navigate("/unidades"))
    }
    verify()
    loadMap()
  }, []);

  function changeShow(event: React.FormEvent) {
    event.preventDefault();
    setShow(!show);
  }
  const login = async (event?: React.FormEvent) => {
    event?.preventDefault();
    setErrorCPF("");
    setErrorPass("");
    setLoading(true)
    const altCPF = (document.querySelector('input[name="cpf"]') as HTMLInputElement).value;
    await auth.signin(cpf || altCPF, password, (error: string) => setErrorPass(error), (error: string) => setErrorCPF(error), () => navigate("/unidades"))
    setLoading(false)
  }
  const cadastrarNovaPessoa = () => {
    setPessoa(newPessoa())
    setActiveIndex(0)
    setShowDialogCadastroPessoa(true)
  }
  const [stationData, setStationData] = useState<StationData[]>([]);
  const fetchDatas = async () => {
    try {
      const response = await axios.get<StationData[]>('https://apitempo.inmet.gov.br/estacoes/T');
      // const response = await axios.get<StationData[]>(`https://apitempo.inmet.gov.br/estacao/dados/t`);
      setStationData(response.data);
      console.log("Dados do INMET:", response.data);
    } catch (error) {
      console.error("Erro ao buscar dados do INMET:", error);
    }
  };
  useEffect(() => {
    const cpfDigits = cpf.replace(/\D/g, '');
    if (cpfDigits.length > 11 && mask === TIPO_MASK.PF) {
      setTimeout(() => setMask(TIPO_MASK.PJ), 50)
    }
  }, [cpf])
  const onCPFChange = (e: InputMaskChangeEvent) => {
    if (!e.originalEvent) return;
    const originalEvent = e.originalEvent as unknown as KeyboardEvent;
    switch (e.originalEvent.type) {
      case 'keydown':
        if (originalEvent.key === 'Delete' || originalEvent.key === 'Backspace' || originalEvent.key === 'Enter') {
          setCPF(e.value || '')
        }
        return
      case 'keypress':
        if (originalEvent.key.search(/\d/) !== -1) { // Se for um número
          const digits = cpf.replace(/\D/g, '') || '';
          if (mask === TIPO_MASK.PF && digits.length >= 11) {
            // Se for PF e já tiver 11 dígitos, adiciona o dígito
            setCPF(`${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 11)}${originalEvent.key}`)
            return
          }
          setCPF(e.value || '')
          return
        }
        return
      case 'paste':
        navigator.clipboard.readText().then((text) => {
          const trimmed = text.trim();
          const isCPF = /^\d{11}$/.test(trimmed) || /^\d{3}.\d{3}\.\d{3}-\d{2}$/.test(trimmed)
          const isCNPJ = /^\d{14}$/.test(trimmed) || /^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/.test(trimmed)
          if (isCPF) {
            setMask(TIPO_MASK.PF);
            const digits = trimmed.replace(/\D/g, '');
            setCPF(`${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9, 11)}`);
          } else if (isCNPJ) {
            setMask(TIPO_MASK.PJ);
            const digits = trimmed.replace(/\D/g, '');
            setCPF(`${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12, 14)}`);
          } else {
            toast.current?.show({ severity: 'error', summary: 'Erro', detail: 'CPF ou CNPJ inválido.' });
          }
        })
    }
  }

  return (
    <div className='login'>
      <div className='opacidade'>
        <div className='container'>
          <div className='form' >
            <Toast ref={toast} position='bottom-center' />
            <div className='div-central'>
              <div style={{ fontSize: '30px', fontFamily: 'Arial Black', color: 'black', marginBottom: '-10px' }}>INVENTÁRIO</div>
              <div style={{ fontSize: '30px', fontFamily: 'Arial Black', color: 'black', marginBottom: '0px' }}>FLORESTAL</div>
              {/* <div style={{ fontSize: '30px', fontFamily: 'Arial Black', color: 'black' }}>ITAIPU</div> */}
              {/* <MonitoraBahiaIcon style={{ width: '64px', height: '64px' }} /> */}
            </div>
            <form onSubmit={login}>
              <div className="loginInput" >
                <MdPerson />
                <InputMask name='cpf' value={cpf} onChange={onCPFChange} mask={mask} placeholder="Digite seu CPF" />
                <div className="btn-show" onClick={() => mask === TIPO_MASK.PF ? setMask(TIPO_MASK.PJ) : setMask(TIPO_MASK.PF)}>{mask === TIPO_MASK.PJ ? <MdDomain /> : <MdGroups />}</div>
              </div>
              {errorCPF && errorCPF.length > 0 && <div className="error">{errorCPF}</div>}
              <div className="loginInput">
                <MdLock />
                <input type={show ? 'text' : 'password'} name='password' value={password} onChange={(e => setPassword(e.target.value))} placeholder="Digite sua senha" />
                <div className="btn-show" onClick={changeShow}>{show ? <MdVisibilityOff /> : <MdVisibility />}</div>
              </div>
              {errorPass && errorPass.length > 0 && <div className="error">{errorPass}</div>}
              <button className="btn-form" type="submit">
                {loading ? <ProgressBar mode="indeterminate" color='white' style={{ backgroundColor: 'black', height: '6px', marginTop: '1px' }} /> : 'ENTRAR'}

              </button>
            </form>
            <CadastroPessoa function={setShowDialogCadastroPessoa} state={showDialogCadastroPessoa} pessoas={[]} pessoa={pessoa} setPessoa={setPessoa} activeIndex={activeIndex} setActiveIndex={setActiveIndex} edit={true} />
            <RecuperarSenhaDialog visible={showRecuperarSenha} onHide={() => setShowRecuperarSenha(false)} onSuccess={() => toast.current?.show({ severity: 'success', summary: 'Sucesso', detail: 'Um e-mail de recuperação de senha foi enviado para o seu endereço de e-mail.' })} />
            <Dialog header="Tutorial - Primeiro Acesso" visible={showTutorialDialog} style={{}} onHide={() => setShowTutorialDialog(false)}>
              <iframe width="480" height="270" src="https://www.powtoon.com/embed/eE21pS31yh5/"></iframe>
            </Dialog>
            <div style={{ display: 'flex', gap: '10px', marginTop: '5px' }}>
              <button className="btn-form" style={{ flex: 1, marginTop: 0, fontSize: 12 }} onClick={cadastrarNovaPessoa}>
                CADASTRAR
              </button>
              <button className="btn-form" style={{ flex: 1, marginTop: 0, fontSize: 12 }} onClick={() => setShowRecuperarSenha(true)}>
                <div></div>RECUPERAR<div style={{ marginTop: -5 }}>SENHA</div>
              </button>
              <button className="btn-form" style={{ flex: 1, marginTop: 0, fontSize: 12 }} onClick={() => setShowTutorialDialog(true)}>
                AJUDA
              </button>
            </div>
          </div>

          <div className='logos'>
            {/* <img src={itaipuLogo} className='itaipuLogo' /> */}
            <img src={iatipuBackLogo} className='itaipuBackLogo' width={100} />
            <LogoEmbrapa className='embrapaLogo' />
            {/* <img src={adabLogo} className='adabLogo' /> */}
            {/* <img src={aibaLogo} className='aibaLogo' /> */}
          </div>
        </div>
      </div>

      <div id='map' className='mapa-back' ref={mapRef} />

    </div >
  );
}

export default Login;